export const pluralize = (
  count: number,
  singular: string,
  plural?: string,
): string => {
  const pluralForm = plural ?? singular + 's';
  return `${count} ${count === 1 ? singular : pluralForm}`;
};
